
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonOptional from '@/components/molecules/ButtonOptional.vue'
import { InformationPanelColorSet } from '@/const/manage/InformationPanelColorSet'

/**
 * 管理側インフォメーションパネルのユーザ情報
 */
@Component({
  components: {
    ButtonBase,
    ImageBase,
    ButtonOptional,
  },
})
export default class InformationPanelUser extends Vue {
  /** インフォメーションパネルのカラーセット */
  @Prop()
  private informationPanelColorSet!: InformationPanelColorSet.ColorSet

  /** ユーザの画像URL */
  @Prop()
  private imageUrl!: string

  /** ユーザID */
  @Prop()
  private userId!: string

  /** 戻るボタン押下時のイベント */
  @Prop()
  private eventBackButton!: () => void

  /** 編集ボタン押下時のイベント */
  @Prop()
  private eventClickEditButton!: () => void

  /** ログアウトボタン押下時のイベント */
  @Prop()
  private eventClickLogoutButton!: () => void

  /** パスワード変更ボタン押下時のイベント */
  @Prop()
  private eventClickChangePasswordButton!: () => void

  /**
   * インフォメーションパネルの色を設定する
   *
   * @returns css：カラー変数文字列
   */
  private get setStyle(): { [key: string]: string } {
    return {
      '--text-color': `var(${this.informationPanelColorSet.text})`,
    }
  }
}
